import { render, staticRenderFns } from "./ImportMaterialModal.vue?vue&type=template&id=59bf3938&scoped=true"
import script from "./ImportMaterialModal.vue?vue&type=script&lang=js"
export * from "./ImportMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./ImportMaterialModal.vue?vue&type=style&index=0&id=59bf3938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf3938",
  null
  
)

export default component.exports